/*! For license information please see qrevocurvc_main.js.LICENSE.txt */ ! function() {
    var s = {
        "./src/js/main.js": function(s, e, t) {
            "use strict";
            t("jquery");
            var i = t("jquery"),
                n = (document.documentElement.clientHeight || window.innerHeight, document.documentElement.clientWidth || window.innerWidth),
                c = n < 750,
                o = getComputedStyle(document.documentElement).getPropertyValue("--content-font-size"),
                r = (n - 12.2 * o) / 2,
                a = 1;
            var p = i(window).scrollTop();
            i(window).on("scroll", (function(s) {
                var e = i(window).scrollTop();
                e > p ? "down" : "up", p = e, i(i.CN(".product-container .section")).each((function(s, e) {
                    i(e).data("section")
                }))
            }));
            var g = null,
                u = null;

            function m(s) {
                s.stopPropagation(), g = s.originalEvent.changedTouches[0].pageX, u = s.originalEvent.changedTouches[0].pageY
            }

            function l(s, e) {
                if (g && u) {
                    var t = s.originalEvent.changedTouches[0].pageX,
                        i = s.originalEvent.changedTouches[0].pageY,
                        n = g - t,
                        c = u - i;
                    Math.abs(n) > Math.abs(c) && (n > 0 ? e.left(n) : e.right(n))
                }
            }

            function v(s) {
                gsap.timeline({
                    yoyo: !0,
                    scrollTrigger: {
                        trigger: i(i.CN(".".concat(s))),
                        start: "top top",
                        end: c ? "bottom bottom-=60%" : "bottom bottom-=25%",
                        scrub: !0,
                        invalidateOnRefresh: !0
                    }
                }).to(i.CN(".".concat(s, " .mask")), {
                    opacity: .5
                }).to(i.CN(".".concat(s, " .content .img-back")), {
                    borderRadius: o * (c ? .7 : 1.5) + "px",
                    width: "96%",
                    height: "96%"
                }, "<").to(i.CN(".".concat(s, " .content .img-back .big-title")), {
                    opacity: 1
                }, "<")
            }

            function f() {
                function s(s) {
                    i(i.CN(".section-thirteenth .tabs-line")).css({
                        transform: "translateX(".concat(Math.min(0, 1.35 * -o * (a - 1) - s), "px)")
                    })
                }

                function e(s) {
                    var e = Math.min(Math.round(s / o * 1.35) + a, 3);
                    i(i.CN(".section-thirteenth .tabs-line")).css({
                        transform: "translateX(".concat(Math.min(0, 1.35 * -o * e), "px)")
                    })
                }

                function t(s) {
                    var e = Math.max(Math.round(s / o * 1.35) + a, 0);
                    i(i.CN(".section-thirteenth .tabs-line")).css({
                        transform: "translateX(".concat(Math.min(0, 1.35 * -o * e), "px)")
                    })
                }

                function n(s) {
                    // i(i.CN(".section-thirteenth .video-block video:nth-child(".concat(a, ")"))).get(0).currentTime = 0, a = i(s).data("number"), i(i.CN(".section-thirteenth .video-block video:nth-child(".concat(a, ")"))).trigger("play")
                }
                i(i.CN(".section-thirteenth .video-block video")).each((function(s, e) {
                    i(e).on("ended", (function(s) {
                        var t = i(e).data("number");
                        a = 4 === t ? 1 : t + 1, i(i.CN(".section-thirteenth .video-block video:nth-child(".concat(a, ")"))).trigger("play")
                    })), i(e).on("play", (function(s) {
                        var t = i(e).data("number");
                        c && i(i.CN(".section-thirteenth .tabs-line")).css({
                            transform: "translateX(".concat(1.35 * -o * (t - 1), "px)")
                        }), i(i.CN(".section-thirteenth .tabs-line .tab-item")).removeClass("".concat("qrevocurvc_", "active")), i(i.CN(".section-thirteenth .tabs-line .tab-item:nth-child(".concat(t, ")"))).addClass("".concat("qrevocurvc_", "active")), i(i.CN(".section-thirteenth .video-block video")).css({
                            display: "none"
                        }), i(i.CN(".section-thirteenth .video-block video:nth-child(".concat(a, ")"))).css({
                            display: "block"
                        }), 1 !== t ? i(i.CN(".section-thirteenth .video-block .top-tip-block")).css({
                            opacity: 0
                        }) : i(i.CN(".section-thirteenth .video-block .top-tip-block")).css({
                            opacity: 1
                        })
                    }))
                })), i(i.CN(".section-thirteenth .tabs-line .tab-item")).each((function(s, e) {
                    i(e).on("click", (function(s) {
                        s.stopPropagation(), i(i.CN(".section-thirteenth .video-block video")).trigger("pause"), i(i.CN(".section-thirteenth .video-block video:nth-child(".concat(a, ")"))).get(0).currentTime = 0, n(e)
                    }))
                })), i(i.CN(".section-thirteenth .tabs-line")).on("touchstart", m), i(i.CN(".section-thirteenth .tabs-line")).on("touchmove", (function(e) {
                    e.stopPropagation(), l(e, {
                        left: s,
                        right: s
                    })
                })), i(i.CN(".section-thirteenth .tabs-line")).on("touchend", (function(s) {
                    s.stopPropagation(),
                        function(s, e) {
                            if (g && u) {
                                var t = s.originalEvent.changedTouches[0].pageX,
                                    i = s.originalEvent.changedTouches[0].pageY,
                                    n = g - t,
                                    c = u - i;
                                Math.abs(n) > Math.abs(c) && (n > 0 ? e.leftEnd(n) : e.rightEnd(n))
                            }
                        }(s, {
                            leftEnd: e,
                            rightEnd: t
                        })
                })), ScrollTrigger.create({
                    trigger: i.CN(".section-thirteenth .tabs-line"),
                    onEnter: function(s) {
                        a = 1, n(i(i.CN(".section-thirteenth .video-block video:nth-child(".concat(a, ")"))))
                    },
                    once: !0,
                    scrub: !0,
                    invalidateOnRefresh: !0
                })
            }
            var d = document.querySelector(i.CN(".section-twentieth .swiper")),
                b = d.querySelector(i.CN(".section-twentieth .swiper-wrapper")),
                _ = d.querySelectorAll(i.CN(".section-twentieth .swiper-slide"));

            function j(s) {
                var e = s.slides[0].offsetWidth;
                if (c) {
                    var t = 0;
                    i(i.CN(".section-twentieth .swiper-slide .desc")).each((function() {
                        t = Math.max(t, i(this).outerHeight())
                    })), i(i.CN(".section-twentieth .swiper-slide")).css({
                        height: t + i(i.CN(".section-twentieth .swiper-slide .video-holder")).height()
                    })
                } else {
                    i(i.CN(".section-twentieth  .nav-part .swiper-pagination")).css({
                        width: e
                    }), i(i.CN(".section-twentieth .swiper")).css({
                        marginLeft: r
                    });
                    var n = 0;
                    i(i.CN(".section-twentieth .swiper-slide .text-part")).each((function() {
                        n = Math.max(n, i(this).outerHeight())
                    })), i(i.CN(".section-twentieth .swiper-slide")).css({
                        height: n + e
                    })
                }
                i(i.CN(".section-twentieth  .bottom-text-part")).css({
                    width: e
                })
            }
            _.forEach((function(s, e) {
                var t = s.cloneNode(!0);
                b.appendChild(t)
            })), n > 2500 && _.forEach((function(s, e) {
                var t = s.cloneNode(!0);
                b.appendChild(t)
            })), i(i.CN(".section-twentieth .swiper-pagination-bullet")).click((function() {
                var s = i(this).index();
                w.slideTo(s)
            }));
            var w = window.abc = new Swiper(i.CN(".section-twentieth .swiper"), {
                slidesPerView: "auto",
                loop: !0,
                autoHeight: !0,
                slidesOffsetBefore: 0,
                slideToClickedSlide: !0,
                centeredSlides: c,
                navigation: {
                    nextEl: i.CN(".section-twentieth  .swiper-button-next"),
                    prevEl: i.CN(".section-twentieth  .swiper-button-prev")
                },
                on: {
                    init: function(s) {
                        var e = s.slides[0].offsetWidth;
                        i(i.CN(".section-twentieth .nav-part .swiper-pagination")).css({
                            width: e
                        });
                        var t = 0;
                        i(i.CN(".section-twentieth .swiper-slide")).each((function() {
                            t = Math.max(t, i(this).outerHeight())
                        })), i(i.CN(".section-twentieth .swiper-slide")).css({
                            height: t
                        })
                    },
                    resize: j,
                    slideChange: function() {
                        var s = this.realIndex % i(i.CN(".section-twentieth .swiper-pagination-bullet")).length;
                        i(i.CN(".section-twentieth  .title-part .title")).removeClass("".concat("qrevocurvc_", "active")), i(i.CN(".section-twentieth  .title-part .title")).eq(s).addClass("".concat("qrevocurvc_", "active")), i(i.CN(".section-twentieth  .bottom-text-part .text")).removeClass("".concat("qrevocurvc_", "active")), i(i.CN(".section-twentieth  .bottom-text-part .text")).eq(s).addClass("".concat("qrevocurvc_", "active")), i(i.CN(".section-twentieth .swiper-pagination-bullet")).removeClass("swiper-pagination-bullet-active"), i(i.CN(".section-twentieth .swiper-pagination-bullet")).get(s).classList.add("swiper-pagination-bullet-active")
                    }
                }
            });
            i(window).on("resize", (function(s) {
                n = document.documentElement.clientWidth || window.innerWidth, o = getComputedStyle(document.documentElement).getPropertyValue("--content-font-size"), r = (n - 12.2 * o) / 2, j(w)
            })), i(document).ready((function() {
                var s;
                i(i.CN(".fadein-up")).each((function() {
                        gsap.set(i(this), {
                            opacity: 0,
                            y: 60
                        }), gsap.fromTo(i(this), {
                            y: 60,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1,
                            duration: .5,
                            ease: "power2.easeOut",
                            immediateRender: !0,
                            scrollTrigger: {
                                trigger: i(this),
                                start: "top bottom-=15%",
                                end: "top+=50px bottom-=" + (c ? "15%" : "10%"),
                                invalidateOnRefresh: !0,
                                toggleActions: "play none reverse none"
                            },
                            delay: Number(i(this).attr("delay")) || 0
                        })
                    })), i(i.CN(".container-fadein-up-list")).each((function() {
                        var s = i(this).attr("start") || "30%",
                            e = gsap.timeline({
                                scrollTrigger: {
                                    trigger: i(this),
                                    start: "top bottom-=" + (c ? "15%" : s),
                                    end: "top+=50px bottom-=" + (c ? "15%" : "10%"),
                                    invalidateOnRefresh: !0,
                                    toggleActions: "play none reverse none"
                                },
                                onComplete: function() {
                                    ScrollTrigger.refresh()
                                }
                            });
                        i(this).find(i.CN(".fadein-up-list")).each((function(s, t) {
                            gsap.set(i(t), {
                                opacity: 0,
                                y: 100
                            }), e.fromTo(i(t), {
                                y: 100,
                                opacity: 0
                            }, {
                                y: 0,
                                opacity: 1,
                                duration: .5,
                                ease: "power0.easeOut",
                                immediateRender: !0
                            }, "<40%")
                        }))
                    })), v("section-forth"), v("section-sixth"), v("section-tenth"), v("section-fourteenth"), v("section-XXI"), ScrollTrigger.create({
                        trigger: i.CN(".section-second .desc-back"),
                        start: "top bottom-=50%",
                        end: "bottom top+=30%",
                        onUpdate: function(s) {
                            i(i.CN(".section-second .desc-back .mask")).css({
                                "-webkit-mask-image": "radial-gradient(circle at 50% 0, white " + 100 * s.progress + "%,  transparent " + (50 + 100 * s.progress) + "%)",
                                "mask-image": "radial-gradient(circle at 50% 0, white " + 100 * s.progress + "%,  transparent " + (50 + 100 * s.progress) + "%)"
                            })
                        },
                        scrub: !0,
                        invalidateOnRefresh: !0
                    }), ScrollTrigger.create({
                        trigger: i.CN(".section-seventh .img-block"),
                        start: "center bottom",
                        end: "center center",
                        onUpdate: function(s) {
                            i(i.CN(".section-seventh .img-block .number")).text("".concat(parseInt(18500 * s.progress).toLocaleString()))
                        },
                        scrub: !0,
                        invalidateOnRefresh: !0
                    }), ScrollTrigger.create({
                        trigger: i.CN(".section-ninth .letter-back"),
                        start: "top bottom-=25%",
                        end: "bottom bottom-=25%",
                        onUpdate: function(s) {
                            i(i.CN(".section-ninth .letter-back .img")).css({
                                bottom: "".concat(100 * (s.progress - 1), "%")
                            }), i(i.CN(".section-ninth .letter-mask")).css({
                                opacity: "".concat(s.progress)
                            })
                        },
                        scrub: !0,
                        invalidateOnRefresh: !0
                    }), f(),
                    function() {
                        var s = c ? 1.15 : 1.55,
                            e = gsap.timeline({
                                repeat: -1,
                                paused: !0
                            }).to(i.CN(".section-XXII .half-img .my-swiper-slide:nth-child(1)"), {
                                y: -o * s,
                                duration: .5
                            }).to(i.CN(".section-XXII .half-img .my-swiper-slide:nth-child(1)"), {
                                opacity: 0,
                                duration: .3
                            }, ">1").to(i.CN(".section-XXII .half-img .my-swiper-slide:nth-child(2)"), {
                                y: -o * s,
                                duration: .5
                            }, ">").to(i.CN(".section-XXII .half-img .my-swiper-slide:nth-child(2)"), {
                                opacity: 0,
                                duration: .3
                            }, ">1").to(i.CN(".section-XXII .half-img .my-swiper-slide:nth-child(3)"), {
                                y: -o * s,
                                duration: .5
                            }, ">").to(i.CN(".section-XXII .half-img .my-swiper-slide:nth-child(3)"), {
                                opacity: 0,
                                duration: .3
                            }, ">1");
                        if (ScrollTrigger.create({
                                trigger: i.CN(".section-XXII .half-img .swiper"),
                                onEnter: function(s) {
                                    e.play()
                                },
                                once: !0,
                                scrub: !0,
                                invalidateOnRefresh: !0
                            }), c) {
                            var t = new Swiper(i.CN(".section-XXII .card-swiper"), {
                                speed: 3e3,
                                loop: !0,
                                slidesPerView: "auto",
                                autoplay: !1,
                                slidesOffsetBefore: .3 * o,
                                spaceBetween: .06 * o
                            });
                            ScrollTrigger.create({
                                trigger: i.CN(".section-XXII .card-swiper"),
                                onEnter: function(s) {
                                    t.autoplay.start()
                                },
                                scrub: !0,
                                once: !0,
                                invalidateOnRefresh: !0
                            })
                        }
                    }(),
                    function() {
                        // if (i(i.CN(".section-XXIII .card .btn-block")).on("click", (function(s) {
                        //         s.stopPropagation(), i(i.CN(".section-XXIII .card")).hasClass("".concat("qrevocurvc_", "night")) ? i(i.CN(".section-XXIII .card")).removeClass("".concat("qrevocurvc_", "night")) : i(i.CN(".section-XXIII .card")).addClass("".concat("qrevocurvc_", "night"))
                        //     })), ScrollTrigger.create({
                        //         trigger: i.CN(".section-XXII"),
                        //         start: "top top",
                        //         onEnter: function() {
                        //             ScrollTrigger.create({
                        //                 trigger: i.CN(".section-XXIII"),
                        //                 start: "center bottom-=50%",
                        //                 end: "center bottom-=50%",
                        //                 onEnter: function(s) {
                        //                     i(i.CN(".section-XXIII .card")).addClass("".concat("qrevocurvc_", "night"))
                        //                 },
                        //                 onEnterBack: function(s) {
                        //                     i(i.CN(".section-XXIII .card")).removeClass("".concat("qrevocurvc_", "night"))
                        //                 },
                        //                 scrub: !0,
                        //                 invalidateOnRefresh: !0
                        //             })
                        //         },
                        //         once: !0,
                        //         scrub: !0,
                        //         invalidateOnRefresh: !0
                        //     }), c) {
                        //     var s = function() {
                        //             i(i.CN(".section-XXIII .card")).hasClass("".concat("qrevocurvc_", "night")) || i(i.CN(".section-XXIII .card")).addClass("".concat("qrevocurvc_", "night"))
                        //         },
                        //         e = function() {
                        //             i(i.CN(".section-XXIII .card")).hasClass("".concat("qrevocurvc_", "night")) && i(i.CN(".section-XXIII .card")).removeClass("".concat("qrevocurvc_", "night"))
                        //         };
                        //     i(i.CN(".section-XXIII .card")).on("touchstart", m), i(i.CN(".section-XXIII .card")).on("touchend", (function(t) {
                        //         t.stopPropagation(), l(t, {
                        //             left: e,
                        //             right: s
                        //         })
                        //     }))
                        // }
                    }(), s = gsap.timeline({
                        yoyo: !0,
                        duration: 1,
                        paused: !0
                    }).to(i.CN(".section-XXV .title-block .page-title img"), {
                        opacity: 1
                    }).to(i.CN(".section-XXV .title-block .page-title span"), {
                        left: o * (c ? .52 : 1)
                    }, "<"), ScrollTrigger.create({
                        trigger: i.CN(".section-XXV .title-block"),
                        start: "top top+=50%",
                        end: "top top+=50%",
                        onEnter: function(e) {
                            s.play()
                        },
                        onEnterBack: function(e) {
                            s.reverse()
                        },
                        scrub: !0,
                        invalidateOnRefresh: !0
                    }), c ? ScrollTrigger.create({
                        trigger: i.CN(".section-XXV"),
                        start: "bottom bottom-=20%",
                        end: "bottom bottom-=20%",
                        onEnter: function(s) {
                            i(i.CN(".section-XXV .card .icon")).addClass("".concat("qrevocurvc_", "active"))
                        },
                        onEnterBack: function(s) {
                            i(i.CN(".section-XXV .card .icon")).removeClass("".concat("qrevocurvc_", "active"))
                        },
                        scrub: !0,
                        invalidateOnRefresh: !0
                    }) : ScrollTrigger.create({
                        trigger: i.CN(".section-XXV .card .icon"),
                        start: "center bottom-=20%",
                        end: "center bottom-=20%",
                        onEnter: function(s) {
                            i(i.CN(".section-XXV .card .icon")).addClass("".concat("qrevocurvc_", "active"))
                        },
                        onEnterBack: function(s) {
                            i(i.CN(".section-XXV .card .icon")).removeClass("".concat("qrevocurvc_", "active"))
                        },
                        scrub: !0,
                        invalidateOnRefresh: !0
                    }), j(w), i(i.CN(".section-third .btn")).on("click", (function() {
                        i(i.CN(".section-modal")).css({
                            display: "block"
                        }), i(i.CN(".section-modal")).scrollTop(0)
                    })), i(i.CN(".section-sixteenth .btn-block")).on("click", (function() {
                        i(i.CN(".section-modal")).css({
                            display: "block"
                        }), i(i.CN(".section-modal")).scrollTop(0)
                    })), i(i.CN(".section-modal .close-icon")).on("click", (function() {
                        i(i.CN(".section-modal")).css({
                            display: "none"
                        })
                    })), i(i.CN(".section-modal .second .arrow-line")).on("click", (function() {
                        i(i.CN(".section-modal .second .arrow-line")).css({
                            display: "none"
                        }), i(i.CN(".section-modal .second .content")).css({
                            display: "block"
                        }), i(i.CN(".section-modal .second .comment-content")).css({
                            display: "block"
                        })
                    }))
            })), window.onload = function() {}
        },
        "./src/widgets/Album/index.js": function(s, e, t) {
            "use strict";

            function i() {
                document.documentElement.clientWidth || window.innerWidth;
                new Swiper("#qSwiperAlbum", {
                    grabCursor: !0,
                    speed: 2e4,
                    loop: !0,
                    slidesPerView: "auto",
                    a11y: {
                        slideRole: "listitem"
                    },
                    autoplay: {
                        pauseOnMouseEnter: !0,
                        disableOnInteraction: !1,
                        delay: 0
                    }
                }), new Swiper("#qSwiperAlbum-1", {
                    grabCursor: !0,
                    speed: 16e3,
                    loop: !0,
                    slidesPerView: "auto",
                    a11y: {
                        slideRole: "listitem"
                    },
                    autoplay: {
                        pauseOnMouseEnter: !0,
                        disableOnInteraction: !1,
                        delay: 0
                    }
                })
            }
            t.d(e, {
                default: function() {
                    return i
                }
            })
        },
        "./src/widgets/ClassExtension.js": function(s, e, t) {
            ! function(s) {
                s.extend({
                    CN: function(s) {
                        return s.startsWith(".") ? s.split(" ").map((function(s) {
                            return s.startsWith(".swiper") ? s : s.startsWith(".") ? ".".concat("qrevocurvc_").concat(s.slice(1)) : s
                        })).join(" ") : "qrevocurvc_" + s
                    }
                })
            }(t("jquery"))
        },
        "./src/widgets/ContrastContainer/index.js": function(s, e, t) {
            "use strict";
            var i = t("jquery");

            function n(s, e) {
                return function(s) {
                    if (Array.isArray(s)) return s
                }(s) || function(s, e) {
                    var t = null == s ? null : "undefined" != typeof Symbol && s[Symbol.iterator] || s["@@iterator"];
                    if (null != t) {
                        var i, n, c, o, r = [],
                            a = !0,
                            p = !1;
                        try {
                            if (c = (t = t.call(s)).next, 0 === e) {
                                if (Object(t) !== t) return;
                                a = !1
                            } else
                                for (; !(a = (i = c.call(t)).done) && (r.push(i.value), r.length !== e); a = !0);
                        } catch (s) {
                            p = !0, n = s
                        } finally {
                            try {
                                if (!a && null != t.return && (o = t.return(), Object(o) !== o)) return
                            } finally {
                                if (p) throw n
                            }
                        }
                        return r
                    }
                }(s, e) || function(s, e) {
                    if (!s) return;
                    if ("string" == typeof s) return c(s, e);
                    var t = Object.prototype.toString.call(s).slice(8, -1);
                    "Object" === t && s.constructor && (t = s.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(s);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return c(s, e)
                }(s, e) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                }()
            }

            function c(s, e) {
                (null == e || e > s.length) && (e = s.length);
                for (var t = 0, i = new Array(e); t < e; t++) i[t] = s[t];
                return i
            }
            i((function() {
                var s = document.documentElement.clientWidth || window.innerWidth;
                ! function() {
                    var e, t, c = JSON.parse((null === (e = document.getElementById("compare_data")) || void 0 === e ? void 0 : e.text) || "{}"),
                        o = (t = c, JSON.parse(JSON.stringify(t)));

                    function r(e) {
                        var t = "";
                        Object.entries(e).forEach((function(e, i) {
                            var o = n(e, 2),
                                r = o[0],
                                a = o[1];
                            i > (s > 750 ? 2 : 1) || (t += '<div class="'.concat("qrevocurvc_", 'item">\n          <img src="').concat(a.imgsrc, '" alt="').concat(a.name, '">\n          <div class="').concat("qrevocurvc_", 'h4">').concat(a.name, '\n            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M1.5 1L6.5 6L11.5 1" stroke="#DB2D30" stroke-width="2" stroke-linecap="round"/>\n            </svg>\n            <div class="').concat("qrevocurvc_", 'popup">\n              <div class="').concat("qrevocurvc_", 'models">').concat(a.choose, "</div>"), Object.entries(c).forEach((function(s) {
                                var e = n(s, 2),
                                    i = e[0],
                                    c = e[1];
                                t += '<p class="'.concat("qrevocurvc_", 'modlist" parentlevel="').concat(r, '" productname="').concat(i, '">\n                <svg class="').concat(a.name == c.name ? "".concat("qrevocurvc_", "active") : "", '" width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n                  <path d="M1.33346 3L4.33354 6L10.0002 1" stroke="black" stroke-width="1.5" stroke-linecap="round"/>\n                </svg><span>').concat(c.name, "</span></p>")
                            })), t += "</div>\n          </div>\n          <div>", a.open_purchase ? t += '<button class="'.concat("qrevocurvc_", 'buy-now purchase-sales-channel-btn" product-name="').concat(a.name.replaceAll(" ", "-").replaceAll("Roborock-", ""), '" data-toggle="modal" data-target="#product-sales-channel">').concat(a.btntext, "</button>") : t += '<a href="'.concat(a.btn_link, '"><button class="').concat("qrevocurvc_", 'buy-now">').concat(a.btntext, "</button></a>"), t += "</div>\n          <ul>", Object.entries(a).forEach((function(s) {
                                var e = n(s, 2),
                                    i = e[0],
                                    c = e[1];
                                i.includes("item") && (t += "<li>".concat(c, "</li>"))
                            })), t += "</ul>\n        </div>")
                        })), i("#compare-table").html(t), "function" == typeof ReloadSalesChannelEvents && ReloadSalesChannelEvents()
                    }
                    r(c), i(i.CN(".contrast-container")).on("click", i.CN(".h4"), (function() {
                        i(this).children(i.CN(".popup")).toggle()
                    })), i(document).on("click", (function(s) {
                        i(s.target).closest(i.CN(".contrast-container .h4")).length || i(i.CN(".contrast-container .popup")).hide()
                    })), i(i.CN(".contrast-container")).on("click", i.CN(".h4 .modlist"), (function(s) {
                        var e = i(this).attr("productname"),
                            t = i(this).attr("parentlevel");
                        o[t] = c[e], r(o)
                    }))
                }()
            }))
        },
        "./src/widgets/FullScreenVideo/index.js": function(s, e, t) {
            "use strict";
            var i = t("jquery");
            i((function() {
                function s() {
                    i(i.CN(".full_screen_video")).hide();
                    var s = new window.CustomEvent("hide.all.modals");
                    document.dispatchEvent(s)
                }! function() {
                    var s = document.querySelectorAll(i.CN(".as-youtube-video"));
                    if (s.length > 0) {
                        var e = document.createElement("script");
                        e.src = "https://www.youtube.com/iframe_api";
                        var t = document.getElementsByTagName("script")[0];
                        t.parentNode.insertBefore(e, t);
                        var n = [],
                            c = function(s) {
                                document.addEventListener("hide.all.modals", (function(s) {
                                    for (var e = 0; e < n.length; e++) n[e].pauseVideo()
                                }))
                            };
                        window.onYouTubeIframeAPIReady = function() {
                            for (var e = 0; e < s.length; e++) n.push(new window.YT.Player(s[e], {
                                events: {
                                    onReady: c
                                }
                            }))
                        }
                    }
                }(), i(i.CN(".section-second .video-back")).on("click", (function(s) {
                    console.log("videoBtn"), i(i.CN(".full_screen_video")).show()
                })), i(i.CN(".full_screen_video")).on("click", (function(e) {
                    s()
                })), i(i.CN(".full_screen_video .video-close")).on("click", (function(e) {
                    s()
                }))
            }))
        },
        "./src/widgets/LeftNav/index.js": function(s, e, t) {
            "use strict";
            t("jquery")
        },
        "./src/widgets/SeriseContainer/index.js": function(s, e, t) {
            "use strict";
            var i = t("jquery");
            i((function() {
                i("#sideBtn").on("click", (function() {
                    var s = i(i.CN(".serise-container"));
                    s.hasClass(i.CN("show")) ? s.addClass(i.CN("hide")).removeClass(i.CN("show")) : s.addClass(i.CN("show")).removeClass(i.CN("hide"))
                })), i("#popup-tab").delegate(i.CN(".tabTitle"), "click", (function(s) {
                    i(this).addClass(i.CN("active")).siblings().removeClass(i.CN("active")), i(i.CN(".tabbody .tabCard")).eq(i(this).index()).show().siblings().hide(), i(i.CN(".pc .img")).eq(i(this).index()).addClass(i.CN("active")).siblings().removeClass(i.CN("active")), i(i.CN(".mob .img")).eq(i(this).index()).addClass(i.CN("active")).siblings().removeClass(i.CN("active"))
                }))
            }))
        },
        "./src/widgets/basics.js": function(s, e, t) {
            "use strict";
            t.d(e, {
                basics: function() {
                    return n
                }
            });
            var i = t("jquery");

            function n() {
                i(".ad-bar").length > 0 && i(i.CN(".container")).css({
                    "margin-top": "110px"
                }), i("#product_subscription_b").on("click", (function() {
                    i("#subscribe-modal").css({
                        display: "block"
                    })
                }))
            }
        },
        "./src/widgets/index.js": function(s, e, t) {
            "use strict";
            t("./src/widgets/ContrastContainer/index.js"), t("./src/widgets/FullScreenVideo/index.js"), t("./src/widgets/LeftNav/index.js"), t("./src/widgets/SeriseContainer/index.js"), t("./src/widgets/ClassExtension.js");
            var i = t("./src/widgets/Album/index.js"),
                n = t("./src/widgets/basics.js");
            (0, i.default)(), (0, n.basics)()
        },
        "./src/index.html": function(s, e, t) {
            "use strict";
            var i = t("./node_modules/html-loader/dist/runtime/getUrl.js"),
                n = t.n(i),
                c = new URL(t("./src/assets/images/section1-back.jpg"), t.b),
                o = new URL(t("./src/assets/images/section1-back-mob.jpg"), t.b),
                r = new URL(t("./src/assets/images/section1-icon1.png"), t.b),
                a = new URL(t("./src/assets/images/section1-icon2.png"), t.b),
                p = new URL(t("./src/assets/images/video-icon.png"), t.b),
                g = new URL(t("./src/assets/images/section2-1.jpg"), t.b),
                u = new URL(t("./src/assets/images/section2-normal-b.png"), t.b),
                m = new URL(t("./src/assets/images/section2-hover-b.png"), t.b),
                l = new URL(t("./src/assets/images/section2-1-mb.jpg"), t.b),
                v = new URL(t("./src/assets/images/section2-2.jpg"), t.b),
                f = new URL(t("./src/assets/images/section2-2-mb.jpg"), t.b),
                d = new URL(t("./src/assets/images/section2-3.jpg"), t.b),
                b = new URL(t("./src/assets/images/section2-3-mb.jpg"), t.b),
                _ = new URL(t("./src/assets/images/section2-red.png"), t.b),
                j = new URL(t("./src/assets/images/section2-4.jpg"), t.b),
                w = new URL(t("./src/assets/images/section2-4-mb.jpg"), t.b),
                h = new URL(t("./src/assets/images/section2-normal-w.png"), t.b),
                x = new URL(t("./src/assets/images/section2-5.jpg"), t.b),
                C = new URL(t("./src/assets/images/section2-5-mb.jpg"), t.b),
                Q = new URL(t("./src/assets/images/section3.jpg"), t.b),
                R = new URL(t("./src/assets/images/section3-mob.jpg"), t.b),
                L = new URL(t("./src/assets/images/btn-icon.png"), t.b),
                U = new URL(t("./src/assets/images/section4.jpg"), t.b),
                N = new URL(t("./src/assets/images/section4-mb.jpg"), t.b),
                y = new URL(t("./src/assets/video/section5.mp4"), t.b),
                k = new URL(t("./src/assets/video/section5-mob.mp4"), t.b),
                X = new URL(t("./src/assets/images/section5-1.jpg"), t.b),
                I = new URL(t("./src/assets/images/section5-1-icon1.png"), t.b),
                E = new URL(t("./src/assets/images/section5-1-icon2.png"), t.b),
                S = new URL(t("./src/assets/images/section5-1-icon3.png"), t.b),
                T = new URL(t("./src/assets/images/section5-1-icon1-mob.png"), t.b),
                O = new URL(t("./src/assets/images/section5-1-mob.jpg"), t.b),
                q = new URL(t("./src/assets/images/section5-2-icon1.png"), t.b),
                M = new URL(t("./src/assets/images/section5-2-icon2.png"), t.b),
                V = new URL(t("./src/assets/images/section5-2.jpg"), t.b),
                A = new URL(t("./src/assets/images/section5-2-mob.jpg"), t.b),
                P = new URL(t("./src/assets/images/section5-3.jpg"), t.b),
                B = new URL(t("./src/assets/images/section5-3-mob.png"), t.b),
                W = new URL(t("./src/assets/images/section6.jpg"), t.b),
                H = new URL(t("./src/assets/images/section6-mob.jpg"), t.b),
                Y = new URL(t("./src/assets/images/section7-mob.jpg"), t.b),
                z = new URL(t("./src/assets/images/section7-1.jpg"), t.b),
                J = new URL(t("./src/assets/images/section8-icon.png"), t.b),
                D = new URL(t("./src/assets/video/section8-1.mp4"), t.b),
                F = new URL(t("./src/assets/video/section8-2.mp4"), t.b),
                $ = new URL(t("./src/assets/images/section9.png"), t.b),
                G = new URL(t("./src/assets/images/section9-mob.png"), t.b),
                K = new URL(t("./src/assets/images/section10.jpg"), t.b),
                Z = new URL(t("./src/assets/images/section10-mob.jpg"), t.b),
                ss = new URL(t("./src/assets/video/section11.mp4"), t.b),
                es = new URL(t("./src/assets/video/section11-mob.mp4"), t.b),
                ts = new URL(t("./src/assets/video/section12-1.mp4"), t.b),
                is = new URL(t("./src/assets/video/section12-2.mp4"), t.b),
                ns = new URL(t("./src/assets/video/section13-1.mp4"), t.b),
                cs = new URL(t("./src/assets/video/section13-2.mp4"), t.b),
                os = new URL(t("./src/assets/video/section13-3.mp4"), t.b),
                rs = new URL(t("./src/assets/video/section13-4.mp4"), t.b),
                as = new URL(t("./src/assets/images/section14.jpg"), t.b),
                ps = new URL(t("./src/assets/images/section14-mob.jpg"), t.b),
                gs = new URL(t("./src/assets/video/section15.mp4"), t.b),
                us = new URL(t("./src/assets/images/section16-icon.png"), t.b),
                ms = new URL(t("./src/assets/images/section17-1-icon1.png"), t.b),
                ls = new URL(t("./src/assets/images/section17.jpg"), t.b),
                vs = new URL(t("./src/assets/images/section17-mob.jpg"), t.b),
                fs = new URL(t("./src/assets/images/section18-1.jpg"), t.b),
                ds = new URL(t("./src/assets/images/section18-2.jpg"), t.b),
                bs = new URL(t("./src/assets/images/section18-1-mob.jpg"), t.b),
                _s = new URL(t("./src/assets/images/section18-2-mob.jpg"), t.b),
                js = new URL(t("./src/assets/video/section19.mp4"), t.b),
                ws = new URL(t("./src/assets/video/section19-mob.mp4"), t.b),
                hs = new URL(t("./src/assets/images/section-20-1.jpg"), t.b),
                xs = new URL(t("./src/assets/images/section-20-1-m.jpg"), t.b),
                Cs = new URL(t("./src/assets/images/section-20-2.jpg"), t.b),
                Qs = new URL(t("./src/assets/images/section-20-2-m.jpg"), t.b),
                Rs = new URL(t("./src/assets/images/section-20-3.jpg"), t.b),
                Ls = new URL(t("./src/assets/images/section-20-3-m.jpg"), t.b),
                Us = new URL(t("./src/assets/images/section-20-4.jpg"), t.b),
                Ns = new URL(t("./src/assets/images/section-20-4-m.jpg"), t.b),
                ys = new URL(t("./src/assets/images/section21.jpg"), t.b),
                ks = new URL(t("./src/assets/images/section21-mob.jpg"), t.b),
                Xs = new URL(t("./src/assets/video/section22.mp4"), t.b),
                Is = new URL(t("./src/assets/images/section22-1.png"), t.b),
                Es = new URL(t("./src/assets/images/section22-2.png"), t.b),
                Ss = new URL(t("./src/assets/images/section22-3.png"), t.b),
                Ts = new URL(t("./src/assets/images/section22-4.png"), t.b),
                Os = new URL(t("./src/assets/images/section22-5.png"), t.b),
                qs = new URL(t("./src/assets/images/section22-6.png"), t.b),
                Ms = new URL(t("./src/assets/images/section23-icon1.png"), t.b),
                Vs = new URL(t("./src/assets/images/section23-icon2.png"), t.b),
                As = new URL(t("./src/assets/images/section23-btn.png"), t.b),
                Ps = new URL(t("./src/assets/images/section23-btn-1.png"), t.b),
                Bs = new URL(t("./src/assets/images/section23-1.jpg"), t.b),
                Ws = new URL(t("./src/assets/images/section23-2.jpg"), t.b),
                Hs = new URL(t("./src/assets/images/section23-1-mob.jpg"), t.b),
                Ys = new URL(t("./src/assets/images/section23-2-mob.jpg"), t.b),
                zs = new URL(t("./src/assets/images/section24-1.jpg"), t.b),
                Js = new URL(t("./src/assets/images/section24-1-mob.jpg"), t.b),
                Ds = new URL(t("./src/assets/images/section24-2.jpg"), t.b),
                Fs = new URL(t("./src/assets/images/section24-2-mob.jpg"), t.b),
                $s = new URL(t("./src/assets/images/section25-title.png"), t.b),
                Gs = new URL(t("./src/assets/images/section25-card1.jpg"), t.b),
                Ks = new URL(t("./src/assets/images/section25-card1-mob.jpg"), t.b),
                Zs = new URL(t("./src/assets/video/section25-card2.mp4"), t.b),
                se = new URL(t("./src/assets/images/section25-card3.jpg"), t.b),
                ee = new URL(t("./src/assets/images/section25-card3-mob.jpg"), t.b),
                te = new URL(t("./src/assets/images/section25-card4.png"), t.b),
                ie = new URL(t("./src/assets/images/section25-card4-mob.png"), t.b),
                ne = new URL(t("./src/assets/images/section25-card5.png"), t.b),
                ce = new URL(t("./src/assets/images/section25-card5-1.png"), t.b),
                oe = new URL(t("./src/assets/images/section26-1-mob.jpg"), t.b),
                re = new URL(t("./src/assets/images/section26-1.jpg"), t.b),
                ae = new URL(t("./src/assets/images/section26-1-icon.png"), t.b),
                pe = new URL(t("./src/assets/images/section26-2-mob.jpg"), t.b),
                ge = new URL(t("./src/assets/images/section26-2-icon.png"), t.b),
                ue = new URL(t("./src/assets/images/section26-2.jpg"), t.b),
                me = new URL(t("./src/assets/images/section26-3.jpg"), t.b),
                le = new URL(t("./src/assets/images/section26-3-mob.jpg"), t.b),
                ve = new URL(t("./src/assets/images/section26-4.png"), t.b),
                fe = new URL(t("./src/assets/images/section27-1.jpg"), t.b),
                de = new URL(t("./src/assets/images/section27-1-mob.jpg"), t.b),
                be = new URL(t("./src/assets/images/section27-2.jpg"), t.b),
                _e = new URL(t("./src/assets/images/section27-2-mob.jpg"), t.b),
                je = new URL(t("./src/assets/images/section27-3.jpg"), t.b),
                we = new URL(t("./src/assets/images/section27-3-mob.jpg"), t.b),
                he = new URL(t("./src/assets/images/section28-back.jpg"), t.b),
                xe = new URL(t("./src/assets/images/section28-back-mob.jpg"), t.b),
                Ce = new URL(t("./src/assets/images/modal-1.jpg"), t.b),
                Qe = new URL(t("./src/assets/images/modal-1-mob.jpg"), t.b),
                Re = new URL(t("./src/assets/images/arrow-icon.png"), t.b),
                Le = new URL(t("./src/assets/images/modal-4.jpg"), t.b),
                Ue = new URL(t("./src/assets/images/modal-4-mob.jpg"), t.b),
                Ne = new URL(t("./src/assets/images/modal-2.jpg"), t.b),
                ye = new URL(t("./src/assets/images/modal-2-mob.jpg"), t.b),
                ke = new URL(t("./src/assets/images/modal-3.png"), t.b),
                Xe = new URL(t("./src/assets/images/modal-3-mob.png"), t.b),
                Ie = new URL(t("./src/assets/images/1.jpg"), t.b),
                Ee = new URL(t("./src/assets/images/2.jpg"), t.b),
                Se = new URL(t("./src/assets/images/3.jpg"), t.b),
                Te = new URL(t("./src/assets/images/4.jpg"), t.b),
                Oe = new URL(t("./src/assets/images/5.jpg"), t.b),
                qe = new URL(t("./src/assets/images/6.jpg"), t.b),
                Me = new URL(t("./src/assets/images/7.jpg"), t.b),
                Ve = new URL(t("./src/assets/images/8.jpg"), t.b),
                Ae = new URL(t("./src/assets/images/9.jpg"), t.b),
                Pe = new URL(t("./src/assets/images/10.jpg"), t.b),
                Be = new URL(t("./src/assets/images/11.jpg"), t.b),
                We = new URL(t("./src/assets/images/12.jpg"), t.b),
                He = new URL(t("./src/assets/images/13.jpg"), t.b),
                Ye = new URL(t("./src/assets/images/14.jpg"), t.b),
                ze = new URL(t("./src/assets/images/15.jpg"), t.b),
                Je = new URL(t("./src/assets/images/16.jpg"), t.b),
                De = new URL(t("./src/assets/images/17.jpg"), t.b),
                Fe = new URL(t("./src/assets/images/18.jpg"), t.b),
                $e = new URL(t("./src/assets/images/dimensions-1.png"), t.b),
                Ge = new URL(t("./src/assets/images/dimensions-2.png"), t.b),
                Ke = new URL(t("./src/assets/images/qrevo_curv.png"), t.b),
                Ze = new URL(t("./src/assets/images/qrevo_edge.png"), t.b),
                st = new URL(t("./src/assets/images/qrevo_slim.png"), t.b),
                et = n()(c),
                tt = n()(o),
                it = n()(r),
                nt = n()(a),
                ct = n()(p),
                ot = n()(g),
                rt = n()(u),
                at = n()(m),
                pt = n()(l),
                gt = n()(v),
                ut = n()(f),
                mt = n()(d),
                lt = n()(b),
                vt = n()(_),
                ft = n()(j),
                dt = n()(w),
                bt = n()(h),
                _t = n()(x),
                jt = n()(C),
                wt = n()(Q),
                ht = n()(R),
                xt = n()(L),
                Ct = n()(U),
                Qt = n()(N),
                Rt = n()(y),
                Lt = n()(k),
                Ut = n()(X),
                Nt = n()(I),
                yt = n()(E),
                kt = n()(S),
                Xt = n()(T),
                It = n()(O),
                Et = n()(q),
                St = n()(M),
                Tt = n()(V),
                Ot = n()(A),
                qt = n()(P),
                Mt = n()(B),
                Vt = n()(W),
                At = n()(H),
                Pt = n()(Y),
                Bt = n()(z),
                Wt = n()(J),
                Ht = n()(D),
                Yt = n()(F),
                zt = n()($),
                Jt = n()(G),
                Dt = n()(K),
                Ft = n()(Z),
                $t = n()(ss),
                Gt = n()(es),
                Kt = n()(ts),
                Zt = n()(is),
                si = n()(ns),
                ei = n()(cs),
                ti = n()(os),
                ii = n()(rs),
                ni = n()(as),
                ci = n()(ps),
                oi = n()(gs),
                ri = n()(us),
                ai = n()(ms),
                pi = n()(ls),
                gi = n()(vs),
                ui = n()(fs),
                mi = n()(ds),
                li = n()(bs),
                vi = n()(_s),
                fi = n()(js),
                di = n()(ws),
                bi = n()(hs),
                _i = n()(xs),
                ji = n()(Cs),
                wi = n()(Qs),
                hi = n()(Rs),
                xi = n()(Ls),
                Ci = n()(Us),
                Qi = n()(Ns),
                Ri = n()(ys),
                Li = n()(ks),
                Ui = n()(Xs),
                Ni = n()(Is),
                yi = n()(Es),
                ki = n()(Ss),
                Xi = n()(Ts),
                Ii = n()(Os),
                Ei = n()(qs),
                Si = n()(Ms),
                Ti = n()(Vs),
                Oi = n()(As),
                qi = n()(Ps),
                Mi = n()(Bs),
                Vi = n()(Ws),
                Ai = n()(Hs),
                Pi = n()(Ys),
                Bi = n()(zs),
                Wi = n()(Js),
                Hi = n()(Ds),
                Yi = n()(Fs),
                zi = n()($s),
                Ji = n()(Gs),
                Di = n()(Ks),
                Fi = n()(Zs),
                $i = n()(se),
                Gi = n()(ee),
                Ki = n()(te),
                Zi = n()(ie),
                sn = n()(ne),
                en = n()(ce),
                tn = n()(oe),
                nn = n()(re),
                cn = n()(ae),
                on = n()(pe),
                rn = n()(ge),
                an = n()(ue),
                pn = n()(me),
                gn = n()(le),
                un = n()(ve),
                mn = n()(fe),
                ln = n()(de),
                vn = n()(be),
                fn = n()(_e),
                dn = n()(je),
                bn = n()(we),
                _n = n()(he),
                jn = n()(xe),
                wn = n()(Ce),
                hn = n()(Qe),
                xn = n()(Re),
                Cn = n()(Le),
                Qn = n()(Ue),
                Rn = n()(Ne),
                Ln = n()(ye),
                Un = n()(ke),
                Nn = n()(Xe),
                yn = n()(Ie),
                kn = n()(Ee),
                Xn = n()(Se),
                In = n()(Te),
                En = n()(Oe),
                Sn = n()(qe),
                Tn = n()(Me),
                On = n()(Ve),
                qn = n()(Ae),
                Mn = n()(Pe),
                Vn = n()(Be),
                An = n()(We),
                Pn = n()(He),
                Bn = n()(Ye),
                Wn = n()(ze),
                Hn = n()(Je),
                Yn = n()(De),
                zn = n()(Fe),
                Jn = n()($e),
                Dn = n()(Ge);
            n()(Ke), n()(Ze), n()(st)
        },
        "./node_modules/html-loader/dist/runtime/getUrl.js": function(s) {
            "use strict";
            s.exports = function(s, e) {
                return e || (e = {}), s ? (s = String(s.__esModule ? s.default : s), e.hash && (s += e.hash), e.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(s) ? '"'.concat(s, '"') : s) : s
            }
        },
        "./src/assets/images/1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_1.jpg"
        },
        "./src/assets/images/10.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_10.jpg"
        },
        "./src/assets/images/11.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_11.jpg"
        },
        "./src/assets/images/12.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_12.jpg"
        },
        "./src/assets/images/13.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_13.jpg"
        },
        "./src/assets/images/14.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_14.jpg"
        },
        "./src/assets/images/15.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_15.jpg"
        },
        "./src/assets/images/16.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_16.jpg"
        },
        "./src/assets/images/17.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_17.jpg"
        },
        "./src/assets/images/18.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_18.jpg"
        },
        "./src/assets/images/2.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_2.jpg"
        },
        "./src/assets/images/3.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_3.jpg"
        },
        "./src/assets/images/4.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_4.jpg"
        },
        "./src/assets/images/5.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_5.jpg"
        },
        "./src/assets/images/6.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_6.jpg"
        },
        "./src/assets/images/7.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_7.jpg"
        },
        "./src/assets/images/8.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_8.jpg"
        },
        "./src/assets/images/9.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_9.jpg"
        },
        "./src/assets/images/arrow-icon.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_arrow-icon.png"
        },
        "./src/assets/images/btn-icon.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_btn-icon.png"
        },
        "./src/assets/images/dimensions-1.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_dimensions-1.png"
        },
        "./src/assets/images/dimensions-2.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_dimensions-2.png"
        },
        "./src/assets/images/modal-1-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_modal-1-mob.jpg"
        },
        "./src/assets/images/modal-1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_modal-1.jpg"
        },
        "./src/assets/images/modal-2-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_modal-2-mob.jpg"
        },
        "./src/assets/images/modal-2.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_modal-2.jpg"
        },
        "./src/assets/images/modal-3-mob.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_modal-3-mob.png"
        },
        "./src/assets/images/modal-3.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_modal-3.png"
        },
        "./src/assets/images/modal-4-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_modal-4-mob.jpg"
        },
        "./src/assets/images/modal-4.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_modal-4.jpg"
        },
        "./src/assets/images/qrevo_curv.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_qrevo_curv.png"
        },
        "./src/assets/images/qrevo_edge.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_qrevo_edge.png"
        },
        "./src/assets/images/qrevo_slim.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_qrevo_slim.png"
        },
        "./src/assets/images/section-20-1-m.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section-20-1-m.jpg"
        },
        "./src/assets/images/section-20-1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section-20-1.jpg"
        },
        "./src/assets/images/section-20-2-m.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section-20-2-m.jpg"
        },
        "./src/assets/images/section-20-2.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section-20-2.jpg"
        },
        "./src/assets/images/section-20-3-m.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section-20-3-m.jpg"
        },
        "./src/assets/images/section-20-3.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section-20-3.jpg"
        },
        "./src/assets/images/section-20-4-m.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section-20-4-m.jpg"
        },
        "./src/assets/images/section-20-4.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section-20-4.jpg"
        },
        "./src/assets/images/section1-back-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section1-back-mob.jpg"
        },
        "./src/assets/images/section1-back.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section1-back.jpg"
        },
        "./src/assets/images/section1-icon1.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section1-icon1.png"
        },
        "./src/assets/images/section1-icon2.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section1-icon2.png"
        },
        "./src/assets/images/section10-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section10-mob.jpg"
        },
        "./src/assets/images/section10.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section10.jpg"
        },
        "./src/assets/images/section14-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section14-mob.jpg"
        },
        "./src/assets/images/section14.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section14.jpg"
        },
        "./src/assets/images/section16-icon.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section16-icon.png"
        },
        "./src/assets/images/section17-1-icon1.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section17-1-icon1.png"
        },
        "./src/assets/images/section17-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section17-mob.jpg"
        },
        "./src/assets/images/section17.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section17.jpg"
        },
        "./src/assets/images/section18-1-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section18-1-mob.jpg"
        },
        "./src/assets/images/section18-1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section18-1.jpg"
        },
        "./src/assets/images/section18-2-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section18-2-mob.jpg"
        },
        "./src/assets/images/section18-2.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section18-2.jpg"
        },
        "./src/assets/images/section2-1-mb.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-1-mb.jpg"
        },
        "./src/assets/images/section2-1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-1.jpg"
        },
        "./src/assets/images/section2-2-mb.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-2-mb.jpg"
        },
        "./src/assets/images/section2-2.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-2.jpg"
        },
        "./src/assets/images/section2-3-mb.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-3-mb.jpg"
        },
        "./src/assets/images/section2-3.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-3.jpg"
        },
        "./src/assets/images/section2-4-mb.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-4-mb.jpg"
        },
        "./src/assets/images/section2-4.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-4.jpg"
        },
        "./src/assets/images/section2-5-mb.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-5-mb.jpg"
        },
        "./src/assets/images/section2-5.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-5.jpg"
        },
        "./src/assets/images/section2-hover-b.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-hover-b.png"
        },
        "./src/assets/images/section2-normal-b.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-normal-b.png"
        },
        "./src/assets/images/section2-normal-w.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-normal-w.png"
        },
        "./src/assets/images/section2-red.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section2-red.png"
        },
        "./src/assets/images/section21-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section21-mob.jpg"
        },
        "./src/assets/images/section21.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section21.jpg"
        },
        "./src/assets/images/section22-1.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section22-1.png"
        },
        "./src/assets/images/section22-2.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section22-2.png"
        },
        "./src/assets/images/section22-3.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section22-3.png"
        },
        "./src/assets/images/section22-4.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section22-4.png"
        },
        "./src/assets/images/section22-5.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section22-5.png"
        },
        "./src/assets/images/section22-6.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section22-6.png"
        },
        "./src/assets/images/section23-1-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section23-1-mob.jpg"
        },
        "./src/assets/images/section23-1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section23-1.jpg"
        },
        "./src/assets/images/section23-2-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section23-2-mob.jpg"
        },
        "./src/assets/images/section23-2.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section23-2.jpg"
        },
        "./src/assets/images/section23-btn-1.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section23-btn-1.png"
        },
        "./src/assets/images/section23-btn.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section23-btn.png"
        },
        "./src/assets/images/section23-icon1.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section23-icon1.png"
        },
        "./src/assets/images/section23-icon2.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section23-icon2.png"
        },
        "./src/assets/images/section24-1-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section24-1-mob.jpg"
        },
        "./src/assets/images/section24-1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section24-1.jpg"
        },
        "./src/assets/images/section24-2-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section24-2-mob.jpg"
        },
        "./src/assets/images/section24-2.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section24-2.jpg"
        },
        "./src/assets/images/section25-card1-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section25-card1-mob.jpg"
        },
        "./src/assets/images/section25-card1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section25-card1.jpg"
        },
        "./src/assets/images/section25-card3-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section25-card3-mob.jpg"
        },
        "./src/assets/images/section25-card3.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section25-card3.jpg"
        },
        "./src/assets/images/section25-card4-mob.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section25-card4-mob.png"
        },
        "./src/assets/images/section25-card4.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section25-card4.png"
        },
        "./src/assets/images/section25-card5-1.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section25-card5-1.png"
        },
        "./src/assets/images/section25-card5.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section25-card5.png"
        },
        "./src/assets/images/section25-title.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section25-title.png"
        },
        "./src/assets/images/section26-1-icon.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section26-1-icon.png"
        },
        "./src/assets/images/section26-1-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section26-1-mob.jpg"
        },
        "./src/assets/images/section26-1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section26-1.jpg"
        },
        "./src/assets/images/section26-2-icon.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section26-2-icon.png"
        },
        "./src/assets/images/section26-2-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section26-2-mob.jpg"
        },
        "./src/assets/images/section26-2.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section26-2.jpg"
        },
        "./src/assets/images/section26-3-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section26-3-mob.jpg"
        },
        "./src/assets/images/section26-3.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section26-3.jpg"
        },
        "./src/assets/images/section26-4.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section26-4.png"
        },
        "./src/assets/images/section27-1-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section27-1-mob.jpg"
        },
        "./src/assets/images/section27-1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section27-1.jpg"
        },
        "./src/assets/images/section27-2-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section27-2-mob.jpg"
        },
        "./src/assets/images/section27-2.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section27-2.jpg"
        },
        "./src/assets/images/section27-3-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section27-3-mob.jpg"
        },
        "./src/assets/images/section27-3.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section27-3.jpg"
        },
        "./src/assets/images/section28-back-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section28-back-mob.jpg"
        },
        "./src/assets/images/section28-back.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section28-back.jpg"
        },
        "./src/assets/images/section3-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section3-mob.jpg"
        },
        "./src/assets/images/section3.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section3.jpg"
        },
        "./src/assets/images/section4-mb.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section4-mb.jpg"
        },
        "./src/assets/images/section4.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section4.jpg"
        },
        "./src/assets/images/section5-1-icon1-mob.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-1-icon1-mob.png"
        },
        "./src/assets/images/section5-1-icon1.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-1-icon1.png"
        },
        "./src/assets/images/section5-1-icon2.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-1-icon2.png"
        },
        "./src/assets/images/section5-1-icon3.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-1-icon3.png"
        },
        "./src/assets/images/section5-1-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-1-mob.jpg"
        },
        "./src/assets/images/section5-1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-1.jpg"
        },
        "./src/assets/images/section5-2-icon1.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-2-icon1.png"
        },
        "./src/assets/images/section5-2-icon2.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-2-icon2.png"
        },
        "./src/assets/images/section5-2-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-2-mob.jpg"
        },
        "./src/assets/images/section5-2.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-2.jpg"
        },
        "./src/assets/images/section5-3-mob.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-3-mob.png"
        },
        "./src/assets/images/section5-3.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-3.jpg"
        },
        "./src/assets/images/section6-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section6-mob.jpg"
        },
        "./src/assets/images/section6.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section6.jpg"
        },
        "./src/assets/images/section7-1.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section7-1.jpg"
        },
        "./src/assets/images/section7-mob.jpg": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section7-mob.jpg"
        },
        "./src/assets/images/section8-icon.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section8-icon.png"
        },
        "./src/assets/images/section9-mob.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section9-mob.png"
        },
        "./src/assets/images/section9.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section9.png"
        },
        "./src/assets/images/video-icon.png": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_video-icon.png"
        },
        "./src/assets/video/section11-mob.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section11-mob.mp4"
        },
        "./src/assets/video/section11.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section11.mp4"
        },
        "./src/assets/video/section12-1.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section12-1.mp4"
        },
        "./src/assets/video/section12-2.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section12-2.mp4"
        },
        "./src/assets/video/section13-1.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section13-1.mp4"
        },
        "./src/assets/video/section13-2.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section13-2.mp4"
        },
        "./src/assets/video/section13-3.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section13-3.mp4"
        },
        "./src/assets/video/section13-4.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section13-4.mp4"
        },
        "./src/assets/video/section15.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section15.mp4"
        },
        "./src/assets/video/section19-mob.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section19-mob.mp4"
        },
        "./src/assets/video/section19.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section19.mp4"
        },
        "./src/assets/video/section22.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section22.mp4"
        },
        "./src/assets/video/section25-card2.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section25-card2.mp4"
        },
        "./src/assets/video/section5-mob.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5-mob.mp4"
        },
        "./src/assets/video/section5.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section5.mp4"
        },
        "./src/assets/video/section8-1.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section8-1.mp4"
        },
        "./src/assets/video/section8-2.mp4": function(s, e, t) {
            "use strict";
            s.exports = t.p + "files/qrevocurvc_section8-2.mp4"
        },
        jquery: function(s) {
            "use strict";
            s.exports = $
        }
    },
    e = {};

function t(i) {
    var n = e[i];
    if (void 0 !== n) return n.exports;
    var c = e[i] = {
        exports: {}
    };
    return s[i](c, c.exports, t), c.exports
}
t.m = s, t.n = function(s) {
        var e = s && s.__esModule ? function() {
            return s.default
        } : function() {
            return s
        };
        return t.d(e, {
            a: e
        }), e
    }, t.d = function(s, e) {
        for (var i in e) t.o(e, i) && !t.o(s, i) && Object.defineProperty(s, i, {
            enumerable: !0,
            get: e[i]
        })
    }, t.o = function(s, e) {
        return Object.prototype.hasOwnProperty.call(s, e)
    }, t.p = "/cdn/shop/", t.b = document.baseURI || self.location.href,
    function() {
        "use strict";
        t("./src/index.html"), t("./src/widgets/index.js"), t("./src/js/main.js")
    }()
}();